<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Предоставленные услуги</h3>
            </v-flex>
            <v-flex xs12 sm6>
            </v-flex>
            <v-flex xs12 sm2>
                <v-progress-circular
                        class="ml-3"
                        indeterminate
                        color="primary"
                        :size="70"
                        :width="9"
                        v-if="listLoading.findIndex(function(el) {return el.indexOf('insertFile') > -1}) > -1"
                >
                    <p>
                        Происходит загрузка реестра
                    </p>

                </v-progress-circular>
            </v-flex>

            <v-flex xs12 sm12 md12>
                <v-data-table
                        :items="listService.results"
                        :server-items-length="listService.last_page"
                        :loading="listLoading.includes('fetchListFiles')"
                        hide-default-footer
                        v-model="listService.results"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1">
                    <template v-slot:header>
                        <tr>
                            <th>Код</th>
                            <th>Дата процедуры</th>
                            <th class="justify-center layout mx-0">
                                <v-btn
                                       icon
                                       class="mr-2"
                                       :to="{name: 'hemodialysis_service', params: {'service_id': 'new'}}"
                                >
                                    <v-icon>mdi-pencil-plus</v-icon>
                                </v-btn>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.date_hemodialysis|short_date }}</td>
                                <td class="justify-center layout mx-0">
                                    <v-btn
                                            icon
                                            class="mr-2"
                                            @click="editItem(item)"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                    <template slot="no-data">
                        <v-btn color="primary" @click="initialize">Перегрузить</v-btn>
                    </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="listService.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    listService () {
      return this.$store.getters['hemodialysisService/listService']
    }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('hemodialysisService/fetchListService', {
        pageId: this.pagination.page,
        person_id: this.$route.params.person_id
      })
    },
    editItem (item) {
      this.$router.push({ name: 'hemodialysis_service', params: { 'service_id': item.id } })
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
</style>
